/* Create cart notification */
/* -------------------------------------------------------------------------------------- */
function addMiniCartNotification(
  product_id,
  free_product,
  parentProductQuantity
) {
  $.getJSON("/cart.js").then(function (cart) {
    //console.log(cart);
    if (parentProductQuantity != 0) {
      $("[js-cart-notification]").addClass("active");
      $(".js-cart-items-notification").empty();
      var items = cart.items;
      var index = items.findIndex(
        (item) => Number(item.id) === Number(product_id)
      );
      // Product is in cart
      if (index != -1) {
        /* Se edita esta parte para que solo muestre la cantidad que se agrega en el momento por lo que se llama aquí al input de la página de producto. Si se quiere regrersar 
        a la función original reemplazar $('.js-quantity-input').val(prodQty.value) por $('.js-quantity-input').val(cart_iQuantity) */
        
        const addToCartBtn = document.getElementById("normalAddToCartBtn");
        const isBoxSelected = addToCartBtn?.getAttribute('data-is-box') === 'true';
        const unitPerBox = addToCartBtn?.getAttribute('data-unit-per-box');
        
        let prodQty =
          document.querySelector("[data-actual-product-qty]")?.value || 1;
        var cart_title = items[index].product_title,
          cart_price = items[index].price / 100,
          cart_subtotal = items[index].final_line_price / 100,
          cart_image = "url('" + items[index].image + "')",
          cart_iQuantity = items[index].quantity,
          cart_PropertiesCompare = items[index].properties["productCompare"],
          cart_PropertiesCompareTotal = cart_PropertiesCompare,
          cart_PropertiesTag = items[index].properties["productTagDiscount"];
          cart_itemDiscount = items[index].total_discount;
        $("[data-product-title-popup]").append(cart_title);
        $("[data-product-price-popup]").append(
          new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(cart_price)
        );
        /*
        $("[data-product-subtotal-popup]").append(
          new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(cart_price * prodQty)
        );
        */
        $("[data-product-image-popup]").append(
          '<span class="c-cart-notification__product-image" style="background: ' +
            cart_image +
            'no-repeat center center; background-size: cover;"></span>'
        );
        $("[data-cart-count-bubble]").removeClass("d-none");
        $("[data-cart-count]").text(cart.item_count);
        if (cart_PropertiesCompare != "") {
          $("[data-product-compare-popup]").append(
            new Intl.NumberFormat("es-CL", {
              style: "currency",
              currency: "CLP",
            }).format(cart_PropertiesCompareTotal / 100)
          );
        }
        if (cart_PropertiesTag != "") {
          $(".c-cart-notification__product-price-tag").removeClass("d-none");
          $("[data-product-tag-popup]").append(cart_PropertiesTag);
        } else {
          $(".c-cart-notification__product-price-tag").addClass("d-none");
        }
        $("[js-cart-notification]").attr("data-product-line", index + 1);
        $("[js-cart-notification]").attr("data-product-id", product_id);

        if (isBoxSelected) {
          prodQty = prodQty * unitPerBox
        }

        let productSubTotal = cart_price * prodQty;
        console.log("productSubTotal", productSubTotal)
        if (cart_itemDiscount > 0) {
          productSubTotal = cart_price * prodQty - (cart_itemDiscount / 100)
          console.log("productSubTotal", productSubTotal)
        }

        $(".js-quantity-input").val(prodQty || 1);
        $('[data-product-subtotal-popup]').append(new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(productSubTotal));

        // Activate free product tag
        if (free_product && free_product.length > 0) {
          $("[js-cart-notification-free-product]").addClass("active");
          $("[js-cart-notification-free-product]").attr(
            "data-has-promo",
            free_product
          );
        } else {
          $("[js-cart-notification-free-product]").removeClass("active");
          $("[js-cart-notification-free-product]").attr("data-has-promo", "");
        }
        // Close notification after 3 seconds
        var timeout = setTimeout(function () {
          $("[js-cart-notification]").removeClass("active");
        }, 3000);

        $("[js-cart-notification]").hover(
          function () {
            clearTimeout(timeout);
          },
          function () {
            timeout = setTimeout(function () {
              $("[js-cart-notification]").removeClass("active");
            }, 3000);
          }
        );

        $("[js-cart-notification]").mousemove(function (event) {
          clearTimeout(timeout);
        });
      }
    } else {
      $("[js-cart-notification]").removeClass("active");
      $("[data-cart-count]").text(cart.item_count);
    }
  });
}
/* Update cart */
/* -------------------------------------------------------------------------------------- */
function updateCartNotification(
  iQuantity,
  line_item,
  product_id,
  promoProducts
) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: iQuantity,
      line: line_item,
    },
    dataType: "json",
    success: function () {
      // Render notification cart
      addMiniCartNotification(product_id, promoProducts, iQuantity);
    },
    complete: function () {
      updateFreeProductQuantities(product_id, promoProducts, iQuantity);
    },
    error: function () {},
  });
}
/* ADD free products */
/* -------------------------------------------------------------------------------------- */
function addFreeProduts(
  el,
  promoProducts,
  productFree,
  product_quantity,
  productType,
  productPickup,
  pickupStoreId
) {
  var itemsPromo = el
    .closest("[js-product-card-grid]")
    .find("[js-product-grid-promo-item]");
  if (itemsPromo.length === 0) {
    itemsPromo = promoProducts.split(",");
  }
  if (itemsPromo.length > 0) {
    for (let i = 0; i < itemsPromo.length; i++) {
      var element, promo_product_id, productCompare, productTagDiscount;
      if (typeof itemsPromo[0] === "string") {
        element = itemsPromo[i];
        promo_product_id = parseFloat(itemsPromo[i]);
        productCompare = "";
        productTagDiscount = "";
      } else {
        element = $(itemsPromo[i]);
        promo_product_id = parseFloat(element.attr("data-product-variant-id"));
        productCompare = element.attr("data-product-compare");
        productTagDiscount = element.attr("data-product-tag");
      }
      // ADD Product to cart
      $.ajax({
        url: "/cart/add",
        type: "post",
        data: {
          quantity: product_quantity,
          id: promo_product_id,
          properties: {
            productType,
            productCompare,
            productTagDiscount,
            productPickup,
            pickupStoreId,
            productFree,
          },
        },
        dataType: "json",
        async: false,
        success: function (data) {
          // Send parent product and update cart count
          addMiniCartNotification(productFree, promoProducts, product_quantity);
        },
        error: function (response) {
          $("[js-cart-notification]")
            .find("[text-message-warning]")
            .empty()
            .append(response.responseJSON.errors);
        },
      });
    }
  }
}
/* Update quantity of free products */
/* -------------------------------------------------------------------------------------- */
async function updateFreeProductQuantities(parentProductID, promos, quantity) {
  let promoProds = promos.split(",");
  let prodsToChange = { updates: {} };
  $.getJSON("/cart.js").then(async function (cart) {
    promoProds.forEach((idProductFree) => {
      let cartItem = cart.items.findIndex(
        (item) =>
          item.id == idProductFree &&
          item.properties.productFree == parentProductID
      );
      if (cartItem != -1) {
        let key = cart.items[cartItem].key;
        prodsToChange.updates[key] = quantity;
      }
    });
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: prodsToChange,
      dataType: "json",
      success: function (data) {
        addMiniCartNotification(parentProductID, promos, quantity);
      },
      error: function () {},
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  /* Add to cart - Product */
  /* -------------------------------------------------------------------------------------- */
  $("body").on("click", ".js-add-cart-notification", function (event) {
    event.preventDefault();
    event.stopPropagation();
    var el = $(this),
      product_id = parseFloat(el.attr("data-product-variant-id")),
      product_quantity = parseFloat(el.attr("data-product-quantity")),
      productType = el.attr("data-product-properties"),
      productCompare = el.attr("data-product-compare"),
      productTagDiscount = el.attr("data-product-tag"),
      productPickup = el.attr("data-pickup"),
      pickupStoreId = el.attr("data-pickup-store-id"),
      promoProducts = el.attr("data-has-promo"); // Free product
    // Product loading message on CARD
    el.closest("[js-product-card-grid]")
      .find("[data-loader]")
      .removeClass("d-none");
    el.closest("[js-product-card-grid]")
      .find("[data-add-to-cart-text]")
      .addClass("d-none");
    // Product loading message on QUICKVIEW
    el.closest("#quickviewProduct").find("[data-loader]").removeClass("d-none");
    el.closest("#quickviewProduct")
      .find("[data-add-to-cart-text]")
      .addClass("d-none");
    // ADD Product to cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: product_quantity,
        id: product_id,
        properties: {
          productType,
          productCompare,
          productTagDiscount,
          productPickup,
          pickupStoreId,
          promoProducts,
        },
      },
      dataType: "json",
      success: function () {
        // Turn on notification
        addMiniCartNotification(product_id, promoProducts, product_quantity);
        // Error message
        el.closest("[js-product-card-grid]")
          .find(".js-product-message")
          .addClass("d-none");
        el.closest("#quickviewProduct")
          .find(".js-error-message-content")
          .addClass("d-none");
        el.closest("#quickviewProduct").removeClass("active");
        document.querySelector("body").style.overflow = "auto";
      },
      complete: function () {
        // Product loading message on CARD
        el.closest("[js-product-card-grid]")
          .find("[data-loader]")
          .addClass("d-none");
        el.closest("[js-product-card-grid]")
          .find("[data-add-to-cart-text]")
          .removeClass("d-none");
        // Product loading message on QUICKVIEW
        el.closest("#quickviewProduct")
          .find("[data-loader]")
          .addClass("d-none");
        el.closest("#quickviewProduct")
          .find("[data-add-to-cart-text]")
          .removeClass("d-none");
        // Add to cart free products
        if (promoProducts !== "")
          addFreeProduts(
            el,
            promoProducts,
            product_id,
            product_quantity,
            productType,
            productPickup,
            pickupStoreId
          );
        document.querySelector("body").style.overflow = "auto";
      },
      error: function (response) {
        // Error message
        el.closest("[js-product-card-grid]")
          .find(".js-product-message")
          .removeClass("d-none");
        el.closest("[js-product-card-grid]")
          .find("[text-message-warning]")
          .empty()
          .append(response.responseJSON.description);
        el.closest("#quickviewProduct")
          .find(".js-error-message-content")
          .removeClass("d-none");
        el.closest("#quickviewProduct")
          .find("[text-message-warning]")
          .empty()
          .append(response.responseJSON.description);
        document.querySelector("body").style.overflow = "auto";
      },
    });
  });
  /* Close - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-cart-notification]").on("click", ".js-close-data", function (event) {
    event.preventDefault();
    /* Act on the event */
    var el = $(this),
      item = $(el.attr("data-close"));
    el.removeClass("active");
    item.removeClass("active");
    item.removeAttr("open");
  });
  $("[js-cart-notification]").on("click", ".js-continue", function (event) {
    event.preventDefault();
    /* Act on the event */
    let close = document.querySelector('[data-close=".c-cart-notification"]');
    close.click();
  });
  /* Quantity Product - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-cart-notification]").on("click", "[name=minus]", function (event) {
    event.preventDefault();
    /* Act on the event */
    var spinner = $(this),
      input = spinner
        .closest(".js-notification-quantity")
        .find('input[type="number"]'),
      min = input.attr("min"),
      max = input.attr("max"),
      oldValue = parseFloat(input.val()),
      line_item = parseFloat(
        spinner.closest("[js-cart-notification]").attr("data-product-line")
      ),
      product_id = parseFloat(
        spinner.closest("[js-cart-notification]").attr("data-product-id")
      ),
      promoProducts = $("[js-cart-notification]")
        .find("[js-cart-notification-free-product]")
        .attr("data-has-promo");
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    input.val(newVal);
    input.trigger("change");
    updateCartNotification(newVal, line_item, product_id, promoProducts);
  });

  $("[js-cart-notification]").on("click", "[name=plus]", function (event) {
    event.preventDefault();
    /* Act on the event */
    var spinner = $(this),
      input = spinner
        .closest(".js-notification-quantity")
        .find('input[type="number"]'),
      min = input.attr("min"),
      max = input.attr("max"),
      oldValue = parseFloat(input.val()),
      line_item = parseFloat(
        spinner.closest("[js-cart-notification]").attr("data-product-line")
      ),
      product_id = parseFloat(
        spinner.closest("[js-cart-notification]").attr("data-product-id")
      ),
      promoProducts = $("[js-cart-notification]")
        .find("[js-cart-notification-free-product]")
        .attr("data-has-promo");
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    input.val(newVal);
    input.trigger("change");
    updateCartNotification(newVal, line_item, product_id, promoProducts);
  });

  $("[js-cart-notification]").on(
    "keyup",
    ".js-quantity-input",
    debounce(function () {
      var input = $(this),
        inputValue = parseFloat(input.val()),
        line_item = parseFloat(input.attr("data-index")),
        product_id = parseFloat(
          spinner.closest("[js-cart-notification]").attr("data-product-id")
        ),
        promoProducts = $("[js-cart-notification]")
          .find("[js-cart-notification-free-product]")
          .attr("data-has-promo");
      updateCartNotification(inputValue, line_item, product_id, promoProducts);
    }, 500)
  );
});
